import { AbstractRouterFilter } from '@zk/framework-vue';
import { getToken } from 'common-module/src/util/auth';
import NoPermissionAlert from '@/components/NoPermissionAlert';

export default class CurrentProjectFilter extends AbstractRouterFilter {
  order() {
    return super.order() + 8;
  }
  matches(to, from) {
    return super.matches(to, from) && getToken() &&
      to.meta.share !== true &&
      !to.path.startsWith('/setting/') &&
      !to.path.startsWith('/dashboard') &&
      !to.path.startsWith('/release') &&
      !to.path.startsWith('/roadmap') &&
      !to.path.startsWith('/team') &&
      !to.path.startsWith('/404');
  }

  async onBefore(to) {
    const { option: { store } } = this;
    const projectList = store.getters['app/getProjectList'];
    const currentProject = store.getters['app/currentProject'];

    if (!projectList || projectList.length <= 0) {
      return true;
    }
    const { pid } = to.query;
    if (pid === 'all' || (currentProject && !pid)) {
      return true;
    }

    let project = store.getters['app/getDefaultProject'];
    if (!project && !pid) {
      project = projectList[0];
    }
    if (pid) {
      project = projectList.find(item => item.id === Number(pid));
    }
    if (!project) {
      NoPermissionAlert.show();
      return false;
    }
    await store.dispatch('app/changeProject', project.id);
    if (!store.state.app.currentProject) {
      if (to.name !== 'project-list') {
        return '/project/list';
      }
    }
    return true;
  }
}
